/*
 * navslider.js
 * Nav Slider Controller Javascript
 * @Company: Strange Animals
 * @Author: Safet Ziljkic
 * ----------------------------------
 */

$(function() {
    //Nav Slider - Controller

    var hamburgerButton = $('.hamburger');
    var $navSlider = $('#navslider');
    var $overlay = $('.shade-overlay');

    var $mobileMenu = $('.mobile-nav');
    var $menuItems = '';

    //Format Menus
    $menuItems = $('header .mobile-nav li');
    $menuItems.removeClass('slide-hover ml-auto current active');

    //Controller Function
    function openNav() {
        $navSlider.css('right', '0');
        $menuItems.each(function(index, elem) {
            $(this).css({
                transitionDelay: 100 + 50 * index + 'ms'
            });
        });
        hamburgerButton.addClass('open');
        $mobileMenu.addClass('open');
        $overlay.fadeIn('fast');
    }

    function closeNav() {
        $navSlider.css('right', '-270px');
        hamburgerButton.removeClass('open');
        $mobileMenu.removeClass('open');
        $overlay.fadeOut('fast');
    }

    //Event Handlers

    hamburgerButton.unbind('click').click(function(event) {
        event.preventDefault();
        if ($mobileMenu.hasClass('open')) {
            closeNav();
        } else {
            openNav();
        }
    });

    $(window).on('resize', function() {
        if ($mobileMenu.hasClass('open')) {
            hamburgerButton.trigger('click');
        }
    });
});
